import "react-native-url-polyfill/auto";
import { polyfillWebCrypto } from "expo-standard-web-crypto";
import { randomUUID } from "expo-crypto";
import { Platform } from "react-native";

polyfillWebCrypto();

function installNitroFetch() {
  if (Platform.OS === "web") return;

  try {
    const { fetch: nitroFetch } = require("react-native-nitro-fetch");
    if (typeof nitroFetch !== "function") return;

    Object.defineProperty(globalThis, "fetch", {
      value: nitroFetch,
      writable: true,
      configurable: true,
    });
  } catch {
    // Native builds without Nitro Fetch should keep the platform fetch.
  }
}

installNitroFetch();

// app-web's Content-Security-Policy allows no eval
// (web/contentSecurityPolicy.ts). The first time zod parses an object it
// probes for eval with `new Function("")`; it catches the refusal, but the
// browser still reports a violation on every page load. jitless skips the
// probe, and zod parses without its compiled fast path.
if (Platform.OS === "web") {
  require("zod").config({ jitless: true });
}

// Shaka (and some other libs) explicitly calls `window.crypto.randomUUID()`.
// `randomUUID` is not available in all browsers / non-secure contexts, so we polyfill it.
// We patch both `globalThis.crypto` and `window.crypto` to cover both access patterns.
const cryptoCandidates = [
  typeof globalThis !== "undefined" ? globalThis.crypto : undefined,
  typeof window !== "undefined" ? window.crypto : undefined,
].filter(Boolean);

for (const c of cryptoCandidates) {
  if (typeof c.randomUUID !== "function") {
    try {
      // Prefer defineProperty in case the object is non-writable in some envs
      Object.defineProperty(c, "randomUUID", {
        value: randomUUID,
        writable: true,
        configurable: true,
      });
    } catch {
      // Fallback to direct assignment
      c.randomUUID = randomUUID;
    }
  }
}
